var GrouponSDSCommon,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

require('./subscriptions_ui.coffee');

GrouponSDSCommon = (function() {
  var COMMON_MOBILE_DISPLAY_EXPERIMENT, NAQ_APP_NAMES, SEO_MOBILE_DISPLAY_EXPERIMENT, TWENTYFOUR_HOURS_LIFE_IN_SECONDS;

  function GrouponSDSCommon() {}

  TWENTYFOUR_HOURS_LIFE_IN_SECONDS = 24 * 60 * 60;

  NAQ_APP_NAMES = ['merchant-page', 'coupon_itier'];

  COMMON_MOBILE_DISPLAY_EXPERIMENT = "subscription-flow-mobile-show-experiment";

  SEO_MOBILE_DISPLAY_EXPERIMENT = "subscription-flow-mobile-seo-show-experiment";

  GrouponSDSCommon.log = function(title, info) {
    if (info == null) {
      info = {};
    }
    if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub : void 0) != null) {
      if (info['goalType'] == null) {
        info['goalType'] = 'subscription';
      }
      if (info['uiSource'] == null) {
        info['uiSource'] = "sds";
      }
      try {
        return OptimizeSuite.TrackingHub.add(title, info);
      } catch (error) {
        return null;
      }
    }
  };

  GrouponSDSCommon.dismissModal = function(container) {
    if (container != null) {
      if (typeof container.hide === "function") {
        container.hide();
      }
      if (typeof container.hideSpotlight === "function") {
        container.hideSpotlight();
      }
      return $('#global-container').show();
    }
  };

  GrouponSDSCommon.getAppName = function() {
    var ref, ref1;
    if (($('head').attr('data-app') != null) && $('head').attr('data-app').length > 0) {
      return encodeURIComponent($('head').attr('data-app'));
    } else if (((typeof Optimize !== "undefined" && Optimize !== null ? (ref = Optimize.suiteData) != null ? ref.app : void 0 : void 0) != null) && (typeof Optimize !== "undefined" && Optimize !== null ? (ref1 = Optimize.suiteData) != null ? ref1.app.length : void 0 : void 0) > 0) {
      return encodeURIComponent(Optimize.suiteData.app);
    }
  };

  GrouponSDSCommon.showSuccessNotification = function() {
    if ($('#email_subscription_subanner').length > 0) {
      $('#email_subscription_subanner').show();
    }
    if ($('#notice_banner').length > 0) {
      return $('#notice_banner').show();
    }
  };

  GrouponSDSCommon.gtmSubscribeEvent = function() {
    return typeof dataLayer !== "undefined" && dataLayer !== null ? dataLayer.push({
      'event': 'subscription'
    }) : void 0;
  };

  GrouponSDSCommon.gtmSubscribeLandingEvent = function(subsave) {
    if (subsave == null) {
      subsave = false;
    }
    if (subsave) {
      return typeof dataLayer !== "undefined" && dataLayer !== null ? dataLayer.push({
        'event': 'subscription/save'
      }) : void 0;
    } else {
      return typeof dataLayer !== "undefined" && dataLayer !== null ? dataLayer.push({
        'event': 'subscription/landing'
      }) : void 0;
    }
  };

  GrouponSDSCommon.isSubForced = function() {
    var ref, ref1;
    return (typeof window !== "undefined" && window !== null ? (ref = window.location) != null ? (ref1 = ref.href) != null ? ref1.indexOf('subs_force=') : void 0 : void 0 : void 0) > -1;
  };

  GrouponSDSCommon.fpBasedShow = function(fpShowFn, fpHideFn) {
    var fpCookie, fpHide;
    fpCookie = Cookie.get('subs_fp_hide');
    if (fpCookie == null) {
      return fpShowFn();
    }
    Cookie.unset('subs_fp_hide', $('head').data('domain'));
    fpHide = fpCookie === '1';
    if (fpHide) {
      Cookie.set('hide_sub_modal', 1);
      fpHideFn();
    } else {
      fpShowFn();
    }
    return GrouponSDSCommon.log('subscriptionFpHide', {
      fpHide: fpHide
    });
  };

  GrouponSDSCommon.isEmailClickTraffic = function() {
    var ref, utm_medium;
    if ((typeof window !== "undefined" && window !== null ? (ref = window.location) != null ? ref.href : void 0 : void 0) != null) {
      utm_medium = new RegExp('[\\?&]utm_medium=([^&#]*)').exec(window.location.href);
    }
    if (((utm_medium != null) && (utm_medium[1] != null) && utm_medium[1].toLowerCase() === 'email') || ((typeof Cookie !== "undefined" && Cookie !== null) && Cookie.get('_tpmed') === 'email')) {
      return true;
    } else {
      return false;
    }
  };

  GrouponSDSCommon.isMobileSeoSkippingTraffic = function(url) {
    var appName, isSemTraffic, isTouchTraffic, mobileHideModal, ref, ref1, ref2, ref3;
    if (url == null) {
      url = window.location.href;
    }
    isSemTraffic = url.indexOf('utm_source') > -1 || url.indexOf('utm_campaign') > -1 || url.indexOf('utm_medium') > -1;
    isTouchTraffic = (ref = typeof TrackingHub !== "undefined" && TrackingHub !== null ? (ref1 = TrackingHub.user) != null ? (ref2 = ref1.deviceType) != null ? ref2.toLowerCase() : void 0 : void 0 : void 0) === 'mobile' || ref === 'tablet';
    if (isSemTraffic || !isTouchTraffic) {
      return false;
    }
    appName = (ref3 = GrouponSDSCommon.getAppName()) != null ? ref3.toLowerCase() : void 0;
    mobileHideModal = appName === 'seo-platform-itier' || appName === 'merchant-page';
    return mobileHideModal;
  };

  GrouponSDSCommon.isMobileSkippingTraffic = function() {
    var appName, mobileHideModal, ref, ref1, ref2;
    if ((typeof TrackingHub !== "undefined" && TrackingHub !== null ? (ref = TrackingHub.user) != null ? (ref1 = ref.deviceType) != null ? ref1.toLowerCase() : void 0 : void 0 : void 0) !== 'mobile') {
      return false;
    }
    mobileHideModal = false;
    appName = (ref2 = GrouponSDSCommon.getAppName()) != null ? ref2.toLowerCase() : void 0;
    if (appName === 'seo-platform-itier' || appName === 'gsm-ita') {
      if (typeof Finch !== "undefined" && Finch !== null) {
        if (typeof Finch.experiment === "function") {
          Finch.experiment(SEO_MOBILE_DISPLAY_EXPERIMENT, {
            hideForMobile: function() {
              return mobileHideModal = true;
            },
            showForMobile: function() {
              return mobileHideModal = false;
            }
          });
        }
      }
    } else {
      if (typeof Finch !== "undefined" && Finch !== null) {
        if (typeof Finch.experiment === "function") {
          Finch.experiment(COMMON_MOBILE_DISPLAY_EXPERIMENT, {
            hideForMobile: function() {
              return mobileHideModal = true;
            },
            showForMobile: function() {
              return mobileHideModal = false;
            }
          });
        }
      }
    }
    return mobileHideModal;
  };

  GrouponSDSCommon.isNAQTraffic = function(url) {
    var appName, entries, ref, ref1, utm_campaign;
    if (url == null) {
      url = window.location.href;
    }
    appName = (ref = GrouponSDSCommon.getAppName()) != null ? ref.toLowerCase() : void 0;
    utm_campaign = new RegExp('[\\?&]utm_campaign=([^&#]*)').exec(url);
    if (indexOf.call(NAQ_APP_NAMES, appName) >= 0 && ((utm_campaign != null ? utm_campaign[1] : void 0) != null)) {
      entries = utm_campaign[1].split("_");
      if (((ref1 = entries[5]) != null ? ref1.toLowerCase() : void 0) === "naq") {
        return true;
      }
    }
    return false;
  };

  GrouponSDSCommon.isSkippingTraffic = function(url) {
    var countryDomain, result;
    if (url == null) {
      url = window.location.href;
    }
    countryDomain = $('head').data('domain') || '';
    result = GrouponSDSCommon.isMobileSkippingTraffic();
    if (result && (typeof Cookie !== "undefined" && Cookie !== null)) {
      Cookie.set("hide_sub_modal", 1, TWENTYFOUR_HOURS_LIFE_IN_SECONDS, countryDomain);
    }
    return result;
  };

  GrouponSDSCommon.setupSuccessCallback = function() {
    var appName, previousDivision, ref;
    previousDivision = typeof Cookie !== "undefined" && Cookie !== null ? Cookie.get('division') : void 0;
    appName = (ref = GrouponSDSCommon.getAppName()) != null ? ref.toLowerCase() : void 0;
    if (appName === 'pull') {
      return window._subscriptionSuccessCallback = function(divisionId, postalCode) {
        var ref1;
        GrouponSDSCommon.gtmSubscribeEvent();
        if (!((ref1 = window.SubscriptionsUI) != null ? ref1._should_show_doi() : void 0) && previousDivision !== divisionId) {
          return window.location = "/browse/" + divisionId + "?post_subscribe=true";
        } else {
          return GrouponSDSCommon.showSuccessNotification();
        }
      };
    } else {
      return window._subscriptionSuccessCallback = function() {
        GrouponSDSCommon.gtmSubscribeEvent();
        return GrouponSDSCommon.showSuccessNotification();
      };
    }
  };

  return GrouponSDSCommon;

})();

window.GrouponSDSCommon = GrouponSDSCommon;

window._useSDS = true;

//# sourceMappingURL=data:application/json;base64,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
